import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    referralType: Yup.string().required('Pole jest wymagane'),
    importantInformation: Yup.string().required('Pole jest wymagane'),
    researchInLastMonths: Yup.string(),
    isPregnat: Yup.string().required('Pole wymagane').nullable(),
    ...sharedSchema,
});
